import React from "react";
import PropTypes from "prop-types";

import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function SupportResourcesInfoHeader({ isNightMode }) {
  return (
    <span
      style={{
        margin: 0,
        justifySelf: "flex-end"
      }}
    >
      <IoInformationCircleOutline
        id="info-icon"
        size={24}
        data-tooltip-variant={isNightMode ? "dark" : "light"}
      />
      <ReactTooltip
        id="info-icon-tooltip"
        place="top"
        anchorId="info-icon"
        className={`custom-tooltip ${isNightMode ? "dark" : "light"}`}
        multiline
      >
        <p style={{ textAlign: "center" }}>
          Enables ticket assignment default employee.
        </p>
        <div>
          1. Start by choosing a assignment style. IRIS will use this to
          automatically populate the assigned user when assigning a ticket.
        </div>
        <div>2. Then add resources that will contribute to this project.</div>
      </ReactTooltip>
    </span>
  );
}

SupportResourcesInfoHeader.propTypes = {
  isNightMode: PropTypes.bool
};
